<template>
  <div>
    <search-group  :span="24" :btnOffset="18" :btnSpan="6" :multipleLines="true" :inline="true" @search="findData" @clear="clearValue">

      <Row :gutter="24" class="mb16">
        <Col span="4">
          <Select placeholder="合作模式" v-model="searchData.invoiceSource" >
            <!--<Option value=""></Option>-->
            <Option v-for="(item,index) in cooperationModeEnums"
                    :value="item.value" :key="'keyA'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="6">
          <Select placeholder="项目名称" v-model="searchData.projectFid">
            <!--<Option value="" v-if="!(''+searchData.invoiceSource)">请先选择合作模式</Option>-->
            <Option value="" v-if="(searchData.invoiceSource+'') && projectList.length>0">请选择</Option>
            <Option v-if="(''+searchData.invoiceSource) && projectList.length>0" v-for="(item,index) in projectList"
                    :key="'keyX'+index" :value="item.value">{{item.text}}</Option>
            <Option v-if="(''+searchData.invoiceSource) && projectList.length==0" value="">暂无项目</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="费用项" v-model="searchData.feeType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in invoiceFeeType"
                    :value="item.value" :key="'keyA'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="发票类型" v-model="searchData.invoiceType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in addInvoiceType"
                    :value="item.value" :key="'keyB'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="6">
          <DatePicker type="datetimerange" style="display: block"  placeholder="申请日期"
                      v-model="searchData.dateList"></DatePicker>
        </Col>

      </Row>
      <Row :gutter="24">
        <Col span="4">
          <Input placeholder="房间号" v-model="searchData.stockNumber" @keyup.enter.native="findData"/>
        </Col>

        <Col span="6">
          <Input placeholder="发票抬头" v-model="searchData.invoiceTitle" @keyup.enter.native="findData"/>
        </Col>
        <Col span="4">
          <Input placeholder="合同号" v-model="searchData.contractCode" @keyup.enter.native="findData"/>
        </Col>
      </Row>
    </search-group>
  </div>
</template>

<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import {invoicelistcondition,projectByCooperationMode} from "../../../../api/invoice";
  import {formatDateTime} from "../../../../utils/format";


  export default {
    // name: "SearchList",
    components: {
      // SearchGroup
    },
    data() {
      return {
        projectList:[],
        searchData: {
          "applyEndTime": "",
          "applyStartTime": "",
          "contractCode": "",
          "feeType": "",
          "invoiceSource": 1,
          "invoiceTitle": "",
          "invoiceType": "",
          "limit": 10,
          "page": 1,
          "projectFid": "",
          "projectFids": "",
          "stockNumber": "",
          dateList: []
        },
        cooperationModeEnums: [{text:'托管',value:1}],
        invoiceFeeType: [],
        addInvoiceType: []
      }
    },
    methods: {
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, true)
      },
      findData() {
        this.searchData.applyStartTime = this.format(this.searchData.dateList[0])
        this.searchData.applyEndTime = this.format(this.searchData.dateList[1])
        this.$emit('findData', this.searchData);
      },
      clearValue() {
        this.searchData = {
          "applyEndTime": "",
          "applyStartTime": "",
          "contractCode": "",
          "feeType": "",
          "invoiceSource": '',
          "invoiceTitle": "",
          "invoiceType": "",
          "limit": 10,
          "page": 1,
          "projectFid": "",
          "projectFids": "",
          "stockNumber": "",
          dateList: ['','']
        }
      }
    },
    created() {
      invoicelistcondition().then(res => {
        // this.cooperationModeEnums = res.data.cooperationModeEnums
        this.invoiceFeeType = res.data.invoiceFeeType
        this.addInvoiceType = res.data.addInvoiceType
      }).catch(error => {})

      let params={
        projectCooperationModel:1
      }
      projectByCooperationMode(params).then(res=>{
        this.projectList=res.data
      }).catch(error=>{})
    }
  }
</script>

<style scoped>
  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

</style>
